import { Injectable } from '@angular/core';
import { setDefaultOptions } from 'date-fns';
import { ptBR } from 'date-fns/locale';

@Injectable({
    providedIn: 'root',
})
export class DateFnsConfigService {
    constructor() {
        this.setLocale();
    }

    private setLocale() {
        setDefaultOptions({ locale: ptBR });
    }
}
